
<mat-card [ngStyle]="{'--card-image-width': '70%'}" (click)="redirectTo(dataCardHelp.linkCard ?? '')">
    <mat-card-content class="container-img">
      <img mat-card-image
           [alt]="dataCardHelp.alt"
           [src]="dataCardHelp.imageUrl"
           [title]="dataCardHelp.title ?? '' | translate">
      <div class="card-text">
        <h4>{{ dataCardHelp.titleCard ?? '' | translate }}</h4>
        <p>{{ dataCardHelp.excerpt ?? '' | translate }}</p>
        <a href="">Leer el artículo <span class="material-icons-outlined">arrow_forward_ios</span>
  </a>
      </div>
    </mat-card-content>
  </mat-card>
